module.exports = __webpack_public_path__ + "img/3D渲染ico.cd9250c6.png";